export default __webpack_public_path__ + "static/media/home-startup-service-img-03.ae1d289f.jpg";